import styled from 'styled-components'

export const ButtonIcon = styled.div`
  display: inline;
  cursor: pointer;
`
